// Canonical-layer grouping of value-creation lever families into board-facing
// program groups. The org levers (delayering, span-of-control right-sizing, and
// workforce reduction) all act on the same internal labor / org-cost pool and
// are de-conflicted against one another, so a board pack should present them as
// ONE "Organization" program with sub-lines rather than three look-alike rows.
//
// Grouping is declared here as config/derivation keyed by lever family id — the
// renderer never string-matches on labels. A family with no entry here is its
// own standalone program.

export type LeverFamilyGroup = Readonly<{
  groupId: string;
  label: string;
}>;

const ORGANIZATION_GROUP: LeverFamilyGroup = Object.freeze({
  groupId: 'organization',
  label: 'Organization',
});

// leverFamilyId -> program group. Add new grouped families here; never infer a
// group from a rendered label.
const GROUP_BY_FAMILY_ID: Record<string, LeverFamilyGroup> = Object.freeze({
  delayering: ORGANIZATION_GROUP,
  span_of_control_rightsizing: ORGANIZATION_GROUP,
  workforce_reduction: ORGANIZATION_GROUP,
});

export function getLeverFamilyGroup(
  leverFamilyId: string,
): LeverFamilyGroup | null {
  return GROUP_BY_FAMILY_ID[leverFamilyId] ?? null;
}

export function listLeverFamilyGroupMemberIds(groupId: string): string[] {
  return Object.entries(GROUP_BY_FAMILY_ID)
    .filter(([, group]) => group.groupId === groupId)
    .map(([leverFamilyId]) => leverFamilyId);
}
